import { useMemo } from "react";
import { useIntl } from "react-intl";
import * as Yup from "yup";
import { WITHDRAWAL_TYPES } from ".";

export const FIELDS = {
  FREE_TRANSACTION_COUNT: 'freeTransactionCount',
  TRANSACTION_FEE: 'transactionFee',
  TRANSACTION_MIN_SUM: 'transactionMinSum',
  IS_EARLY_WITHDRAWAL_ENABLED: 'isEarlyWithdrawalEnabled',
  EARLY_WITHDRAWAL_PERCENT: 'earlyWithdrawalPercent',
  EARLY_WITHDRAWAL_DAYS: 'earlyWithdrawalDays',
  EARLY_WITHDRAWAL_FEE: 'earlyWithdrawalFee',
  FAST_WITHDRAWAL_FEE: 'fastWithdrawalFee',
  WITHDRAWAL_TYPE: 'withdrawalType',
  WITHDRAWAL_DAYS: 'withdrawalDays',
  ADMIN_NOTE: 'adminNote',
}

export const useValidationSchema = () => {
  const intl = useIntl();

  return useMemo(() => {
    return Yup.object().shape({
      [FIELDS.FREE_TRANSACTION_COUNT]: Yup.number().min(0, intl.formatMessage({ id: "organizerFreeTransactionCountMinError" })).required(intl.formatMessage({ id: "organizerFreeTransactionCountRequiredError" })),
      [FIELDS.TRANSACTION_FEE]: Yup.number().min(0, intl.formatMessage({ id: "organizerTransactionFeeMinError" })).required(intl.formatMessage({ id: "organizerTransactionFeeRequiredError" })),
      [FIELDS.FAST_WITHDRAWAL_FEE]: Yup.number().min(0, intl.formatMessage({ id: "organizerFastWithdrawalFeeMinError" })).required(intl.formatMessage({ id: "organizerFastWithdrawalFeeRequiredError" })),
      [FIELDS.TRANSACTION_MIN_SUM]: Yup.number().min(0, intl.formatMessage({ id: "organizerTransactionMinSumMinError" })).required(intl.formatMessage({ id: "organizerTransactionMinSumRequiredError" })),
      [FIELDS.IS_EARLY_WITHDRAWAL_ENABLED]: Yup.boolean().optional(),
      [FIELDS.EARLY_WITHDRAWAL_PERCENT]: Yup.number().when(FIELDS.IS_EARLY_WITHDRAWAL_ENABLED, {
        is: true,
        then: (schema) => schema.min(0, intl.formatMessage({ id: "organizerEarlyWithdrawalPercentMinError" })).max(100, intl.formatMessage({ id: "organizerEarlyWithdrawalPercentMaxError" })).required(intl.formatMessage({ id: "organizerEarlyWithdrawalPercentRequiredError" })),
        otherwise: (schema) => schema.optional().nullable(),
      }),
      [FIELDS.EARLY_WITHDRAWAL_DAYS]: Yup.number().when(FIELDS.IS_EARLY_WITHDRAWAL_ENABLED, {
        is: true,
        then: (schema) => schema.min(-365, intl.formatMessage({ id: "organizerEarlyWithdrawalDaysMinError" })).max(365, intl.formatMessage({ id: "organizerEarlyWithdrawalDaysMaxError" })).required(intl.formatMessage({ id: "organizerEarlyWithdrawalDaysRequiredError" })),
        otherwise: (schema) => schema.optional().nullable(),
      }),
      [FIELDS.EARLY_WITHDRAWAL_FEE]: Yup.number().when(FIELDS.IS_EARLY_WITHDRAWAL_ENABLED, {
        is: true,
        then: (schema) => schema.min(0, intl.formatMessage({ id: "organizerEarlyWithdrawalFeeMinError" })).max(100, intl.formatMessage({ id: "organizerEarlyWithdrawalFeeMaxError" })).required(intl.formatMessage({ id: "organizerEarlyWithdrawalFeeRequiredError" })),
        otherwise: (schema) => schema.optional().nullable(),
      }),
      [FIELDS.WITHDRAWAL_TYPE]: Yup.string().required(),
      [FIELDS.WITHDRAWAL_DAYS]: Yup.number().when(FIELDS.WITHDRAWAL_TYPE, {
        is: WITHDRAWAL_TYPES.DAYS,
        then: (schema) => schema.min(0, intl.formatMessage({ id: "organizerWithdrawalDaysMinError" })).required(intl.formatMessage({ id: "organizerWithdrawalDaysRequiredError" })),
        otherwise: (schema) => schema.optional().nullable(),
      }),
      [FIELDS.ADMIN_NOTE]: Yup.string().optional().nullable(),
    })
  }, [intl])
};